import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
// import { makeStyles } from '@material-ui/core/styles'

import EditorTextField from '../../../Common/Input/EditorTextField'
import { updateTag } from '../../../../modules/reducerTagsActions'
import { TAG_PROPERTIES } from '../../../../modules/tag'

// const useStyles = makeStyles((theme) => ({
//   root: {}
// }))

const TEPBText = ({ id, value }) => {
  // const tag = useSelector(getCurrentTag)
  // const classes = useStyles()
  const dispatch = useDispatch()

  const updateTagValue = useCallback(
    (value) => {
      dispatch(updateTag(id, TAG_PROPERTIES.PB_TEXT, value))
    },
    [dispatch, id]
  )

  return (
    <EditorTextField
      label="Texto"
      value={value}
      multiline
      rowsMax={4}
      onChange={updateTagValue}
    />
  )
}
export default TEPBText
